export const productName = '🇦🇷 MEGAPACK YACIMIENTOS DE HIDROCARBUROS LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/bpnNfNkaCoPsF7fSQxreqC/MOCKUP_4.10.47_p._m..png';

export const checkoutUrl = 'https://megapack-yacimientos-de-hidrocarburos-listo.impultienda.ar/checkout';

export const price = '$19.990 ARS';
export const priceBefore = '$119.000 ARS';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = '$70.000 ARS';

export const baseItems = [
  'TOMO 1: Fundamentos de los Yacimientos de Hidrocarburos',
  'TOMO 2: Geología del Petróleo y Sistemas Petroleros',
  'TOMO 3: Rocas Reservorio y Propiedades del Yacimiento',
  'TOMO 4: Trampas, Acumulaciones y Tipos de Yacimientos',
  'TOMO 5: Exploración de Hidrocarburos',
  'TOMO 6: Caracterización y Evaluación de Yacimientos',
  'TOMO 7: Perforación, Terminación y Desarrollo de Yacimientos',
  'TOMO 8: Producción y Gestión del Yacimiento',
  'TOMO 9: Yacimientos de Hidrocarburos en Argentina y su Enseñanza',
  'BONO 1: Kit de 50 Checklists y Formularios de Yacimientos de Hidrocarburos',
  'BONO 2: Kit de Evaluaciones, Rúbricas y Exámenes de Yacimientos de Hidrocarburos',
  'BONO 3: Banco de 150 Actividades Prácticas de Yacimientos de Hidrocarburos',
  'BONO 4: Planificación Anual 2026 + Cronograma Docente',
  'BONO 5: Mega Kit Visual de Yacimientos de Hidrocarburos — 100 Láminas e Infografías',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% argentino', 'Cuencas sedimentarias argentinas, contexto laboral real, políticas de hidrocarburos en Argentina y casos de empresas exploradoras argentinas.'],
  ['Material imprimible', 'Listo para usar en el aula, laboratorio o presentación, o entregar directamente al alumno.'],
  ['Formularios y plantillas reales', 'Checklists de caracterización, planes de exploración, matrices de evaluación, inspecciones técnicas y proyectos adaptados a 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales del campo de los yacimientos de hidrocarburos en Argentina.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles educativos.'],
  ['Conexión con la actualidad', 'Nuevas tecnologías de exploración, nuevos descubrimientos, nuevas normativas, nuevas realidades en el sector hidrocarburífero argentino.'],
  ['Normativa argentina actualizada', 'Leyes, resoluciones y estándares técnicos aplicados a la realidad argentina.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
